<template>
	<div class="sv-notification">
		<sv-checkbox class="" v-model="isCoinRecieved">コイン・いいね！獲得時に通知を受け取る</sv-checkbox>
		<sv-checkbox class="mt-30" v-model="isMemberJoined">メンバー新規追加時に通知を受け取る</sv-checkbox>
		<sv-checkbox class="mt-30" v-model="isNewsPosted">ニュース投稿時に通知を受け取る</sv-checkbox>
		<sv-checkbox class="mt-30" v-model="isNewsCommented">ニュースコメント・いいね！投稿時に通知を受け取る</sv-checkbox>

		<b-button type="is-primary" class="max-w-button mt-50" rounded @click="onSubmitClick">更新</b-button>
		<b-button type="is-info" class="max-w-button mt-20" rounded @click="$router.go(-1)">キャンセル</b-button>
	</div>
</template>

<script>
import SvCheckbox from '@/components/SvCheckbox'

export default {
	name: 'Notification',
	components: {
		SvCheckbox,
	},
	data () {
		return {
			isCoinRecieved: false,
			isMemberJoined: false,
			isNewsPosted: false,
			isNewsCommented: false,
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	methods: {
		onSubmitClick: async function() {
			this.isSubmitLoading = true;
			let data = {
				"is_coin_recieved": this.isCoinRecieved,
				"is_member_joined": this.isMemberJoined,
				"is_news_posted": this.isNewsPosted,
				"is_news_commented": this.isNewsCommented,
			};
			this.$utils.log(data);

			let ep = 'mail-notification-settings';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'my-page' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isSubmitLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'mail-notification-settings';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.isCoinRecieved = res.data.is_coin_recieved;
				this.isMemberJoined = res.data.is_member_joined;
				this.isNewsPosted = res.data.is_news_posted;
				this.isNewsCommented = res.data.is_news_commented;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.sv-notification {
	padding: 10px 15px;
}

@media screen and (min-width: $breakPoint) {
	$sideMargin: 220px;

	.sv-checkbox {
		display: block;
	}

	.sv-notification {
		margin-left: $sideMargin;
		margin-right: $sideMargin;
	}
}
</style>
